import script from "./Stage1Svg.vue?vue&type=script&setup=true&lang=js"
export * from "./Stage1Svg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__